define("settings/components/cluster/social-profile-refresh", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "rsvp", "later/errors/index", "later/utils/constants", "shared/utils/redirect"], function (_exports, _component, _templateFactory, _object, _computed, _service, _component2, _tracking, _emberConcurrency, _rsvp, _index, _constants, _redirect) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"rsvp",0,"later/errors/index",0,"later/utils/constants",0,"shared/utils/redirect"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--btnGroup--block tAC--table__btnGroup" data-test-id="social-profile-refresh">
    {{#if @socialProfileState.action.showOnlyEdit}}
      {{! Placeholder btn to push Edit button to right }}
      <div class="o--btn o--btn--disabled"></div>
    {{else}}
      {{#if this.isRefreshing}}
        <Shared::Ui::Button @isDisabled={{true}} @text={{t "shared_words.refreshing"}} @variant="outline" />
      {{else if this.shouldCredentialsWizard}}
        <Shared::Ui::Button
          @class={{@socialProfileState.action.class}}
          @onClick={{perform @openCredentialsWizard}}
          @text={{@socialProfileState.action.title}}
          @variant="outline"
          data-social-profile-refresh-id={{if
            @socialProfileState.action.isConnectBusiness
            "business-upgrade-button"
            "profile-refresh-button"
          }}
        />
      {{else if @socialProfileState.action.isConnectBusiness}}
        <Shared::Credentials::UpgradeButton
          @buttonClass={{@socialProfileState.action.class}}
          @buttonText={{@socialProfileState.action.title}}
          @path="account.groups.group"
          @socialProfile={{@socialProfile}}
        />
      {{else}}
        <Shared::Ui::Button
          @class={{concat-classes
            @socialProfileState.action.class
            (if @socialProfile.isInstagram "at--autoPublish__socialProfileRefresh")
          }}
          @onClick={{perform this.handleAction @socialProfileState.action.isRefreshToken}}
          @text={{@socialProfileState.action.title}}
          @variant="outline"
          data-social-profile-refresh-id="profile-refresh-button"
          title={{@socialProfile.errorText}}
        />
      {{/if}}
    {{/if}}
    <LinkTo
      @disabled={{not this.isAccountOwner}}
      @model={{@socialProfile.id}}
      @route="groups.group.social_profiles.edit"
      class={{concat-classes "o--btn o--btn--outline" (unless this.isAccountOwner "u--mute")}}
      data-social-profile-refresh-id="profile-refresh-edit"
    >
      {{#unless this.isAccountOwner}}
        <EmberTooltip @event="hover" @popperContainer="body">
          {{t "account.social_accounts.non_admin.edit"}}
        </EmberTooltip>
      {{/unless}}
      {{t "shared_words.edit"}}
    </LinkTo>
  </div>
  
  {{#if this.showTiktokRefreshConfirmationModal}}
    <Shared::Credentials::TiktokRefreshConfirm
      @handleClose={{set this "showTiktokRefreshConfirmationModal" false}}
      @refreshUnverifiedTiktok={{action "refreshUnverifiedTiktok"}}
    />
  {{/if}}
  */
  {
    "id": "xjL3DQM2",
    "block": "[[[10,0],[14,0,\"o--btnGroup--block tAC--table__btnGroup\"],[14,\"data-test-id\",\"social-profile-refresh\"],[12],[1,\"\\n\"],[41,[30,1,[\"action\",\"showOnlyEdit\"]],[[[1,\"    \"],[10,0],[14,0,\"o--btn o--btn--disabled\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isRefreshing\"]],[[[1,\"      \"],[8,[39,1],null,[[\"@isDisabled\",\"@text\",\"@variant\"],[true,[28,[37,2],[\"shared_words.refreshing\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"shouldCredentialsWizard\"]],[[[1,\"      \"],[8,[39,1],[[16,\"data-social-profile-refresh-id\",[52,[30,1,[\"action\",\"isConnectBusiness\"]],\"business-upgrade-button\",\"profile-refresh-button\"]]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[30,1,[\"action\",\"class\"]],[28,[37,3],[[30,2]],null],[30,1,[\"action\",\"title\"]],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"action\",\"isConnectBusiness\"]],[[[1,\"      \"],[8,[39,4],null,[[\"@buttonClass\",\"@buttonText\",\"@path\",\"@socialProfile\"],[[30,1,[\"action\",\"class\"]],[30,1,[\"action\",\"title\"]],\"account.groups.group\",[30,3]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,1],[[24,\"data-social-profile-refresh-id\",\"profile-refresh-button\"],[16,\"title\",[30,3,[\"errorText\"]]]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,5],[[30,1,[\"action\",\"class\"]],[52,[30,3,[\"isInstagram\"]],\"at--autoPublish__socialProfileRefresh\"]],null],[28,[37,3],[[30,0,[\"handleAction\"]],[30,1,[\"action\",\"isRefreshToken\"]]],null],[30,1,[\"action\",\"title\"]],\"outline\"]],null],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[8,[39,6],[[16,0,[28,[37,5],[\"o--btn o--btn--outline\",[52,[51,[30,0,[\"isAccountOwner\"]]],\"u--mute\"]],null]],[24,\"data-social-profile-refresh-id\",\"profile-refresh-edit\"]],[[\"@disabled\",\"@model\",\"@route\"],[[28,[37,8],[[30,0,[\"isAccountOwner\"]]],null],[30,3,[\"id\"]],\"groups.group.social_profiles.edit\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"isAccountOwner\"]]],[[[1,\"      \"],[8,[39,9],null,[[\"@event\",\"@popperContainer\"],[\"hover\",\"body\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"account.social_accounts.non_admin.edit\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[1,[28,[35,2],[\"shared_words.edit\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showTiktokRefreshConfirmationModal\"]],[[[1,\"  \"],[8,[39,10],null,[[\"@handleClose\",\"@refreshUnverifiedTiktok\"],[[28,[37,11],[[30,0],\"showTiktokRefreshConfirmationModal\",false],null],[28,[37,12],[[30,0],\"refreshUnverifiedTiktok\"],null]]],null],[1,\"\\n\"]],[]],null]],[\"@socialProfileState\",\"@openCredentialsWizard\",\"@socialProfile\"],false,[\"if\",\"shared/ui/button\",\"t\",\"perform\",\"shared/credentials/upgrade-button\",\"concat-classes\",\"link-to\",\"unless\",\"not\",\"ember-tooltip\",\"shared/credentials/tiktok-refresh-confirm\",\"set\",\"action\"]]",
    "moduleName": "settings/components/cluster/social-profile-refresh.hbs",
    "isStrictMode": false
  });

  /**
   * @class SocialProfileRefresh
   * @extends Component
   */
  let SocialProfileRefreshComponent = (_dec = (0, _service.inject)('social/facebook-auth'), _dec2 = (0, _service.inject)('social/instagram-business'), _dec3 = (0, _service.inject)('social/connect-profiles'), _dec4 = (0, _computed.reads)('auth.currentUserModel'), _dec5 = (0, _computed.reads)('currentUserModel.admin'), _dec6 = (0, _computed.alias)('laterConfig.facebookAppId'), _dec7 = (0, _computed.filterBy)('auth.socialProfiles', 'isFacebook', true), _dec8 = (0, _computed.and)('args.socialProfile.isProfessional', 'args.socialProfile.hasProfessionalAccount'), _dec9 = (0, _computed.or)('handleAction.isRunning', 'args.openCredentialsWizard.isRunning'), _dec10 = (0, _object.computed)('isProfessional', 'args.socialProfile.needsBasicDisplayTokenRefresh', 'credentials.failedConnections.[]'), (_class = class SocialProfileRefreshComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "ada", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "auth", _descriptor3, this);

      _initializerDefineProperty(this, "credentials", _descriptor4, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor5, this);

      _initializerDefineProperty(this, "errors", _descriptor6, this);

      _initializerDefineProperty(this, "instagram", _descriptor7, this);

      _initializerDefineProperty(this, "intl", _descriptor8, this);

      _initializerDefineProperty(this, "laterConfig", _descriptor9, this);

      _initializerDefineProperty(this, "router", _descriptor10, this);

      _initializerDefineProperty(this, "tiktok", _descriptor11, this);

      _initializerDefineProperty(this, "facebookAuth", _descriptor12, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor13, this);

      _initializerDefineProperty(this, "connectProfiles", _descriptor14, this);

      _initializerDefineProperty(this, "lastRefresh", _descriptor15, this);

      _initializerDefineProperty(this, "showTiktokRefreshConfirmationModal", _descriptor16, this);

      _initializerDefineProperty(this, "currentUserModel", _descriptor17, this);

      _initializerDefineProperty(this, "isAdmin", _descriptor18, this);

      _initializerDefineProperty(this, "facebookAppId", _descriptor19, this);

      _initializerDefineProperty(this, "facebookProfiles", _descriptor20, this);

      _initializerDefineProperty(this, "isProfessional", _descriptor21, this);

      _initializerDefineProperty(this, "isRefreshing", _descriptor22, this);
    }

    get shouldCredentialsWizard() {
      return this.isProfessional && !this.args.socialProfile.needsBasicDisplayTokenRefresh && this.credentials.failedConnections.includes(this.args.socialProfile.id);
    }

    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    /**
     * refresh a Instagram Business Token
     *
     * @method refreshBusinessToken
     * @param {boolean} shiftKey shift key pressed to revoke all permissions
     *
     */


    *refreshBusinessToken(shiftKey) {
      try {
        yield this.facebookAuth.authenticateFacebook(this.instagramBusiness.potentialScopes);
      } catch (error) {
        this.alerts.warning(this.intl.t('shared_phrases.try_again'));
        return;
      }

      if (shiftKey) {
        try {
          yield this.instagramBusiness.revokePermissions.perform(this.args.socialProfile);
          this.alerts.alert(this.intl.t('alerts.account.social_accounts.errors.revoke', {
            date: moment().format('L')
          }));
          return;
        } catch (error) {
          this.alerts.warning(error);
        }
      }

      try {
        yield this.instagramBusiness.refreshBusinessAccountEndpoint(this.args.socialProfile, 'account-settings');
        yield this.args.socialProfile.reload();
      } catch (error) {
        if (error instanceof _index.CredentialsNotFoundError) {
          error.resolve.call(this, this.args.socialProfile);
        } else if (error instanceof _index.RequestError) {
          error.resolve.call(this);
        } else {
          this.errors.log(error);
        }
      }

      this.credentialStatus.checkBrokenProfiles();
    }

    refreshToken() {
      return new _rsvp.default.Promise((resolve, reject) => {
        const {
          socialProfile
        } = this.args;
        const isRefresh = true;
        this.instagram.loginInstagram(socialProfile, isRefresh).then(auth => {
          const response = [auth.uid, auth.credentials.token, auth.scope];
          return Promise.all([...response, this.instagram.fetchBasicDisplayUsername(auth.credentials.token)]);
        }).then(_ref => {
          let [uid, accessToken, scope, username] = _ref;

          if (uid === socialProfile.uid || username === socialProfile.nickname) {
            this.instagramBusiness.updateSocialProfile.perform(socialProfile, accessToken, scope, uid);
            this.credentialStatus.checkBrokenProfiles();
            socialProfile.reload();
            resolve(socialProfile);
          } else {
            this.alerts.warning(this.intl.t('alerts.account.controllers.groups.wrong_profile', {
              social_profile: socialProfile.nickname,
              username
            }));
            reject('The correct Instagram Profile was not found');
          }
        }).catch(error => {
          if (error) {
            this.errors.log(`spr/refreshToken error: ${error}`);
          }

          reject('Could not login to Instagram');
        });
      });
    }

    refreshUnverifiedTiktok() {
      this.tiktok.refresh(this.args.socialProfile);
    }

    *handleAction(forceIgTokenRefresh, event) {
      const {
        socialProfile
      } = this.args;

      try {
        if (socialProfile.isInstagram) {
          const shouldRefreshProfessionalToken = (socialProfile.isProfessional || socialProfile.needsProfessionalTokenRefresh) && this.lastRefresh !== 'businessToken';

          if (forceIgTokenRefresh) {
            this.lastRefresh = 'token';
            yield this.refreshToken();
          } else if (shouldRefreshProfessionalToken) {
            this.lastRefresh = 'businessToken';
            yield this.refreshBusinessToken.perform(event.shiftKey);
            yield socialProfile.save();
            this.ada.closeCampaign();
          } else {
            this.lastRefresh = 'token';
            yield this.refreshToken();
          }
        } else if (socialProfile.isFacebook) {
          yield this.instagramBusiness.refreshFacebook(socialProfile).then(() => this.ada.closeCampaign()).catch(error => {
            this.alerts.alert(error, {
              title: this.intl.t('alerts.account.controllers.groups.facebook.refresh_error_title')
            });
            return this.errors.log(error, {}, 'info');
          });
        } else if (socialProfile.isTiktok) {
          if ((socialProfile.isTiktokUnverifiedAccount || socialProfile.isTiktokLoginKitAccount) && socialProfile.canConnectTiktokApi) {
            this.showTiktokRefreshConfirmationModal = true;
          } else {
            this.tiktok.refresh(socialProfile, `account/groups/${this.auth.currentGroup.id}/social_profiles/`);
          }
        } else {
          let oAuthPath;
          const groupSlug = socialProfile.get('group.slug');

          if (socialProfile.isTwitter) {
            oAuthPath = this.connectProfiles.oAuthPath({
              socialProfileType: _constants.OauthSocialProfileType.Twitter,
              redirectGroupSlug: groupSlug
            });
          } else if (socialProfile.isPinterest) {
            oAuthPath = this.connectProfiles.oAuthPath({
              socialProfileType: _constants.OauthSocialProfileType.Pinterest,
              redirectGroupSlug: groupSlug
            });
          } else if (socialProfile.isLinkedin) {
            oAuthPath = this.connectProfiles.oAuthPath({
              socialProfileType: _constants.OauthSocialProfileType.Linkedin,
              redirectGroupSlug: groupSlug
            });
          } else if (socialProfile.isYoutube) {
            oAuthPath = this.connectProfiles.oAuthPath({
              socialProfileType: _constants.OauthSocialProfileType.Youtube,
              redirectGroupSlug: groupSlug
            });
          }

          if (oAuthPath) {
            const params = `group_id=${socialProfile.get('group.id')}&refresh_social_profile_id=${socialProfile.id}`;
            (0, _redirect.default)(`${oAuthPath}&${params}`);
          }
        }
      } catch (error) {
        this.errors.show(error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "ada", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "laterConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "lastRefresh", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showTiktokRefreshConfirmationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "currentUserModel", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "isAdmin", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "facebookAppId", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "facebookProfiles", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "isProfessional", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isRefreshing", [_dec9], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "shouldCredentialsWizard", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "shouldCredentialsWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshBusinessToken", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "refreshBusinessToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshUnverifiedTiktok", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshUnverifiedTiktok"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAction", [_emberConcurrency.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleAction"), _class.prototype)), _class));
  _exports.default = SocialProfileRefreshComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileRefreshComponent);
});